import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

export function CookieBanner() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    try {
      const consent = localStorage.getItem("cookie-consent");
      if (!consent) {
        // Small delay for better UX
        const timer = setTimeout(() => setIsVisible(true), 1000);
        return () => clearTimeout(timer);
      }
    } catch (_e) {
      // Fallback if localStorage is disabled
      setTimeout(() => setIsVisible(true), 0);
    }
  }, []);

  const handleAccept = () => {
    try {
      localStorage.setItem("cookie-consent", "accepted");
    } catch (e) {
      console.warn("Could not save cookie consent", e);
    }
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[100] w-[calc(100%-2rem)] max-w-lg animate-in fade-in slide-in-from-bottom-8 duration-700 ease-out">
      <div className="glass-panel p-5 shadow-2xl border border-white/20 dark:border-white/5 flex flex-col sm:flex-row items-center gap-5 backdrop-blur-2xl">
        <div className="flex-1 text-sm leading-relaxed text-slate-600 dark:text-slate-300 text-center sm:text-left">
          <span className="font-semibold text-slate-900 dark:text-white block mb-0.5">{t("common.cookie_banner.title", "Küpsiste teavitus")}</span>
          {t("common.cookie_banner.message", "Kasutame küpsiseid, et pakkuda parimat kogemust. Jätkates nõustud meie tingimustega.")}
        </div>
        <button
          onClick={handleAccept}
          className="whitespace-nowrap px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold rounded-xl transition-all shadow-lg shadow-blue-500/25 active:scale-95 hover:scale-[1.02]"
        >
          {t("common.cookie_banner.accept", "Sain aru")}
        </button>
      </div>
    </div>
  );
}
